import { Breadcrumb, Skeleton, Row, Col } from 'antd';
import { ButtonAction, Card, Form, FormItem, generateSlugify, GetValidateFields, Input, Toggle, Confirm, Button } from 'asumsi-components';
import { LayoutCMS } from 'components';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import useAction from '@pages/topics/hooks/useAction';

export const PageTopicsFormComponent = (props: any) => {
    // set header page
    const title = 'Topics'
    const layoutCMSProps = {
        breadcrumb: (
            <>
                <Breadcrumb.Item>
                    {title}
                </Breadcrumb.Item>
            </>
        ),
        documentTitle: title,
        history: props.history,
        pageTitle: title,
    };

    // declare action and attribute needed
    const { isLoader, getDetail, postData, updateData, detail } = useAction();
    const { match } = props;
    const idData = match.params.id;

    // initiate form data
    const initialFieldsValues: any = {
        name: "",
        slug: "",
        description: "",
    };

    const [fieldsValues, setFieldsValues]: any = useState(initialFieldsValues);
    const [showConfirmation, setShowConfirm] = useState(false);
    const [paramSubmit, setParamSubmit] = useState({});

    // first load
    useEffect(() => {
        if (idData && !detail) {
            getDetail(idData);
        }
        if (idData && detail) {
            setDefault();
        }
    }, [detail])

    // fetch data
    const setDefault = async () => {
        if (detail) {
            setFieldsValues({
                name: detail.name,
                slug: detail.slug,
                description: detail.description,
                isActive: detail.isActive
            });
        }
    }

    // const dataDetail: IResponseTopics = detail;

    const onChangeName = (e: any) => {
        const val: string = e.target.value;
        const slug = generateSlugify(val);
        const errors = fieldsValues.errors;
        if (errors) {
            const index = errors.findIndex((element: string) => element == 'slug');
            if (index >= 0) {
                errors.splice(index, 1);
            }
        }

        if (!slug) {
            errors.push('slug');
        }

        setFieldsValues({ ...fieldsValues, errors, slug });
    }

    // handle submit form
    const handleSubmit = (e: any) => {
        const validateFields = GetValidateFields(fieldsValues);
        const { err, values } = validateFields;
        e.preventDefault();
        if (!err) {
            setParamSubmit(values);
            setShowConfirm(true);
        }
    };

    // return JSX Element 
    return (
        <LayoutCMS {...layoutCMSProps}>
            <Card className="asumsi-card-form-shadow-rd-15">
                <Form>
                    <Skeleton loading={isLoader}>
                        <Row gutter={30}>
                            <Col lg={{ span: 24 }} md={{ span: 24 }} xs={{ span: 32 }}>
                                <Row>
                                    <Col span={12}>
                                        <FormItem width="80%" setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} label="Name" labelAlign="left"
                                            fieldDecorator={{
                                                label: "name",
                                                rules: [{
                                                    message: 'Please input name',
                                                    required: true,
                                                }
                                                ]
                                            }}
                                        >
                                            <Input onChange={onChangeName} id="name" defaultValue={fieldsValues.name} />
                                        </FormItem>
                                    </Col>
                                    <Col span={12}>
                                        <FormItem width="50%" setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} label="Slug" labelAlign="left"
                                            fieldDecorator={{
                                                label: "slug",
                                                rules: [{
                                                    message: 'Please input slug',
                                                    required: true,
                                                },
                                                {
                                                    message: "Only alphanumeric and -",
                                                    pattern: /^[a-zA-Z0-9-]+$/,
                                                }]
                                            }}
                                        >
                                            <Input id="slug" defaultValue={fieldsValues.slug} />
                                        </FormItem>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={12}>
                                        <FormItem width="80%" setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} label="Description" labelAlign="left"
                                            fieldDecorator={{
                                                label: "description"
                                            }}
                                        >
                                            <Input id="description" defaultValue={fieldsValues.description} />
                                        </FormItem>
                                    </Col>
                                    <Col span={12}>
                                        <FormItem width="50%" setFieldsValues={setFieldsValues} fieldsValues={fieldsValues} label="Active" labelAlign="left"
                                            fieldDecorator={{
                                                label: "isActive"
                                            }}
                                        >
                                            <Toggle id="isActive" defaultChecked={fieldsValues.isActive} />
                                        </FormItem>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Skeleton>
                    <ButtonAction
                        left={
                            <Link to="/article/topics">
                                <Button type="outline-red" size="medium" disabled={isLoader} text="Cancel"></Button>
                            </Link>
                        }
                        right={
                            <Button type="green" size="medium" disabled={fieldsValues.errors && fieldsValues.errors.length > 0} loading={isLoader} onClick={handleSubmit}>
                                Save
                            </Button>
                        }
                    />
                </Form>
            </Card>
            <Confirm
                key="confirm-save"
                show={showConfirmation}
                setShow={setShowConfirm}
                onOk={async () => {
                    if (!idData) {
                        // do post data
                        postData(paramSubmit);
                    } else {
                        // do update data
                        updateData(paramSubmit, idData);
                    }
                }}
                content='Apakah Anda yakin untuk menyimpan data ini?'
                title='Konfirmasi'
                okText='Ya'
                cancelText='Tidak'
            />
        </LayoutCMS>
    );
};
export default PageTopicsFormComponent;



// WEBPACK FOOTER //
// ./src/pages/topics-form/component.tsx